// Supabase Realtime (broadcast only). The API publishes a "new DM" ping on a
// per-recipient topic derived from a hash of the email; the payload carries no
// message text, so the public anon key exposes nothing beyond "something arrived".
// supabase-js is loaded lazily so the main bundle doesn't pay for it.
const SUPABASE_URL = "https://rxkawusddqtfxmkwgpsj.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_ap8ppxtgu6C3xtU7NCIzcg_7440J7av";

let clientPromise = null;
function client() {
  if (!clientPromise) clientPromise = import("@supabase/supabase-js").then(m => m.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { auth: { persistSession: false, autoRefreshToken: false } }));
  return clientPromise;
}

export async function dmTopic(email) {
  if (!globalThis.crypto?.subtle) return null; // insecure context: no realtime, polling still works
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(String(email).toLowerCase()));
  return "dm:" + [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, "0")).join("").slice(0, 24);
}

// Subscribe to DM pings for `email`. Returns an unsubscribe function.
export function subscribeDMs(email, onPing) {
  let channel = null, dead = false;
  (async () => {
    try {
      const topic = await dmTopic(email);
      if (!topic || dead) return;
      const sb = await client();
      if (dead) return;
      channel = sb.channel(topic, { config: { broadcast: { self: false } } })
        .on("broadcast", { event: "dm" }, ({ payload }) => onPing(payload || {}))
        .subscribe();
    } catch (e) { /* realtime is an accelerator; polling remains the fallback */ }
  })();
  return () => { dead = true; if (channel) client().then(sb => sb.removeChannel(channel)).catch(() => {}); };
}

// ─── White-label: org inbox pings (coach DMs, announcements) ───
// Topic: "org:" + first 24 hex chars of sha256(lower(email)) — same construction
// as dmTopic; payload is { kind: 'dm'|'announcement', ts } only, never content.
export async function orgTopic(email) {
  if (!globalThis.crypto?.subtle) return null;
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(String(email).toLowerCase()));
  return "org:" + [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, "0")).join("").slice(0, 24);
}

export function subscribeOrg(email, onPing) {
  let channel = null, dead = false;
  (async () => {
    try {
      const topic = await orgTopic(email);
      if (!topic || dead) return;
      const sb = await client();
      if (dead) return;
      channel = sb.channel(topic, { config: { broadcast: { self: false } } })
        .on("broadcast", { event: "org" }, ({ payload }) => onPing(payload || {}))
        .subscribe();
    } catch (e) { /* realtime is an accelerator; the 30 s poll remains the fallback */ }
  })();
  return () => { dead = true; if (channel) client().then(sb => sb.removeChannel(channel)).catch(() => {}); };
}
